// extracted by mini-css-extract-plugin
export default {"Stats":"PageHome_Stats__pZ+gq","Stat":"PageHome_Stat__+I7Lu","StatValue":"PageHome_StatValue__sgysW","StatLabel":"PageHome_StatLabel__Pq5To"};